
import { AccountListComponent } from '../account-list/account-list.component';
import * as $ from 'jquery';
import { Component, OnInit, Injector, OnDestroy, Input, Output, EventEmitter,} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonfilterService } from '../../../services/commonfilter.service';
import { AccountService } from '../../../services/account.service';
import { AccountDataSourceService } from '../../../services/account-data-source.service';
import { PaginationService } from '../../../services/pagination.service';
import { DateFormatPipe } from '../../../pipes/dateFormat.pipe';
import { MatDialog } from '@angular/material/dialog';
import { DeleteAccountVerifyComponent } from './delete-account-verify/delete-account-verify.component';
import { projectConstants } from 'src/app/shared/constants/project-constants';
import { DeleteAccountVerifyyComponent } from './delete-account-verifyy/delete-account-verifyy.component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
@Component({
  selector: 'app-account-filter',
  templateUrl: './account-filter.component.html',
  styleUrls: ['./account-filter.component.css'],
  providers: [AccountListComponent]
})
export class AccountFilterComponent implements OnInit, OnDestroy {
  provider_lastName: string;
  provider_firstName: string;
  accountLinkedPhoneNumber: string;
  accountLinkedPhoneNumberSelect: string;
  whatsappLinkedPhoneNumberSelect: string;
  secondaryPhoneNumberSelect: string;
  accountLinkedPhoneNumbertestSelect: string;
  accountLinkedunclaimPhoneNumberSelect: string;
  accountLinkedbranchPhoneNumberSelect: string;
  accountLinkedtestPhoneNumber: string;
  contactLastNameSelect: string;
  contactFirstNameSelect: string;
  accountLinked: string;
  PhoneNumber: string;
  domain: any;
  subDomains: any = [];
  collapsed;
  collapsedlcFilter;
  serviceSectors: any;
  baseLocation: any = [];
  accountData: any = {};
  
  baseLocationModel = 0; serviceSector = 0; serviceSubSector = 0;
  license = 0; categoryModel = 0; userAgentModal = 0; domainModel = 0; licenseModel = 0; accountStatusModel = 0; accountTypeModel = 0; corporateModel = 0;
  deletebranchaccountTypeModel = 'BRANCH';
  // accountclaimModel= 'Unclaimed';
  accountclaimModel;
  hideEmployeeCode = true;
  deleteAccountBtnDiabled = true;

  verifiedOn: any;
  path: any;
  licensePkgs: any;
  accntStatus: string;
  verifyLevels: any = [];
  configData: any = {};
  accountCategory: any;
  claimedStatus: any;
  consumerStatus: any;
  searchfields: any;
  @Input() passedDomain: string;
  @Input() passedkwdet: any = [];
  @Input() passedRefine: any = [];
  @Input() includedfrom: string;
  @Output() searchclick = new EventEmitter<any>();
  tableFilters = '';
  createdDate_operator = 'eq';
  operator = 'eq';
  createdFromDate;
  createdToDate;
  createdDate;
  dt;
  collapseddelaccounts;
  collapseddelclaimaccounts;
  collapseddelbranches;
  collapsedpayment;
  deleteFilters: string;
  accountTypes: any;
  actionTypes: any;
  deletebranchFilters: string;
  delHideEmployeeCode: boolean;
  showToolBar: boolean;
  corporates: any = [];
  screenHeight;
  showbt= false;
  screenWidth;
  showstartend = true;
  showstartendName = true;
  hideUserAgents = true;
  hideUserAgent = true;
  showUnclaimPhone = true;
  UnclaimPhoneAgent = true;
  BranchPhoneAgent = true;
  showbranchPhone = true;
  showstartenduserName = true;
  hideSecondPhone = true;
  showSecondPhone  = true;
  hideuserName = true;
  showstartendwhatsapp = true;
  hidewhatsapp = true;
  hideAgent = true;
  showMoreFilterSection = false;
  hideName = true;
  hidecontactLastName = true;
  showcontactLastName = true;
  hideContactFirstName = true;
 showContactFirstName= true;
  small_device_display = false;
  historyCheckins: any;
  filtervalue: any = [];
  salesChannel: any;
  userAgents: any;
  phone: any;
  loading = false;
  providerLabels: any = [];
  label: any;
  getLbels: any;
  api_success: string;
  api_error: any;
  gatewayTransactionid;
  disableConfirmbtn = false;
  settlementUtr;
  api_err: string;
  apisucces: string;
  constructor(private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonfilterService,
    private accountService: AccountService,
    private accountDataSourceService: AccountDataSourceService,
    private pagination: PaginationService,
    private dialog: MatDialog
  ) {
    this.commonService.getServiceSectors()
      .subscribe(res => {
        this.serviceSectors = res;
      });
    // this.accountService.getCorporates()
    //   .subscribe(data => {
    //     this.corporates = data;
    //   });

    this.commonService.getLicensePackages()
      .subscribe(res => {
        this.licensePkgs = res;
      });
    this.commonService.getConfigData()
      .subscribe(res => {
        this.configData = res;
        this.verifyLevels = this.configData.verifyLevel;
        this.accountCategory = this.configData.analyticsCategory;
        this.userAgents = this.configData.userAgentType;
        this.claimedStatus = this.configData.claimedStatus;
        this.accountTypes = this.configData.accTypes;
        this.actionTypes = this.configData.accStatusTypes;

      });
      this.onResize();
      this.getLabel();

  }

  handlesearchClick(ob) {
    this.searchclick.emit(ob);
  }

  ngOnInit() {
  //  console.log(this.label);
    this.accountLinkedPhoneNumberSelect = 'eq';
    this.whatsappLinkedPhoneNumberSelect = 'eq';
    this.secondaryPhoneNumberSelect = 'eq';
    this.contactFirstNameSelect = 'eq';
    this.contactLastNameSelect = 'eq';
    this.accountLinkedPhoneNumbertestSelect='startWith';
    this.accountLinkedunclaimPhoneNumberSelect='eq';
    this.accountLinkedbranchPhoneNumberSelect='eq';
    this.accountLinkedtestPhoneNumber='55';
    this.accountclaimModel = 'Unclaimed'
    if (this.accountService.getCreatedOperator()) {
      this.createdDate_operator = this.accountService.getCreatedOperator();
    }
    if (this.accountService.getCreatedFromDate()) {
      this.createdFromDate = this.accountService.getCreatedFromDate();
    }
    //  if (this.accountService.getCreatedToDate()) {
    //    this.createdToDate = this.accountService.getCreatedToDate();
    //  }
    if (this.accountService.getCategoryFilterValue()) {
      this.hideUserAgents = false;
      this.categoryModel = this.accountService.getCategoryFilterValue();
    }
    if (this.accountService.getAgentFilterValue()) {
      this.userAgentModal = this.accountService.getAgentFilterValue();
    }
    if (this.accountService.getDomainFilterValue()) {
      this.domainModel = this.accountService.getDomainFilterValue();
    }
    if (this.accountService.getLicenseFilterValue()) {
      this.licenseModel = this.accountService.getLicenseFilterValue();
    }
    if (this.accountService.getAccountStatusFilter()) {
      this.licenseModel = this.accountService.getAccountStatusFilter();
    }
  }

  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
      this.small_device_display = true;
    } else {
      this.small_device_display = false;
    }
  }
  getAccountData() {
    this.accountDataSourceService.setAccountToolBarVal(false);
    this.pagination.resetPage(0);
    const accountFilters = this.commonService.createfilterParams('account');
    const dateRangeFiters = this.createfilterParamsOfDateRange();
    // const phoneNumberFiters = this.createfilterParamsOfphone();  
    const catergoryFilters = this.commonService.filterParams_without_operators('category');
    this.tableFilters = accountFilters + '&' + catergoryFilters + '&' + dateRangeFiters  ;
    this.accountService.getAccountsDatas(this.tableFilters, 'false', 0, 250, this.getLbels)
      .subscribe(res => {
        console.log("AccountData Here:", res);
        this.accountDataSourceService.setAccountData(res);
        this.accountService.getcommonTotalFilterCount(this.tableFilters,this.getLbels)
          .subscribe(data => {
            this.accountDataSourceService.setAccountCount(data);
            this.accountData.count = data;
          });
        this.accountData.filterParam = this.tableFilters;
        this.accountData.flag = true;

        this.accountService.storeAccountData(this.accountData);
        this.router.navigate(['list'], { relativeTo: this.route });

      });
  }
  exportToExcel() {
    const accountFilters = this.commonService.createfilterParams('account');
    const dateRangeFiters = this.createfilterParamsOfDateRange();
    // const phoneNumberFiters = this.createfilterParamsOfphone();  
    const catergoryFilters = this.commonService.filterParams_without_operators('category');
    this.tableFilters = accountFilters + '&' + catergoryFilters + '&' + dateRangeFiters  ;
    this.accountService.getAccountsData(this.tableFilters, 'false', 0, 1000)
    .subscribe(res => {
      this.accountDataSourceService.setAccountData(res);
      console.log(res)
      this.filtervalue = res;

      const accounts = this.filtervalue.reduce((a, o) => (a.push({Business: o.account.businessName, Phone: o.account.accountLinkedPhNo, Email: o.account.accountLinkedEmail}), a), [])  

      console.log(accounts);
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(accounts);
      const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
      const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      this.saveExcelFile(excelBuffer, 'download');
    });
  }
  public saveExcelFile(buffer: any, fileName: string): void {
    let fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let fileExtension = '.xlsx';
    const data: Blob = new Blob([buffer], {type: fileType});
    FileSaver.saveAs(data, fileName + fileExtension);
  }
  printMe(account) {
    this.accountService.getAccountsData(this.tableFilters, 'false', 0, 250)
      .subscribe(res => {
        this.accountDataSourceService.setAccountData(res);
        console.log(res)
        this.filtervalue = res;
        // this.filtervalue.forEach(saleschannel_filter => {
        //   this.salesChannel = saleschannel_filter;
        //   // console.log(this.salesChannel.accContactInfo.primaryPhoneNumber);
        //   this.phone = this.salesChannel.accContactInfo.primaryPhoneNumber
        //  });
       
    // window.print();
    const params = [
      'height=' + screen.height,
      'width=' + screen.width,
      'fullscreen=yes'
    ].join(',');
    const printWindow = window.open('', '', params);
    let checkin_html = '';
    checkin_html += '<table width="100%" style="border: 1px solid #dbdbdb;">';
    checkin_html += '<td>Sl.No.</td>';
    checkin_html += '<td>Business Name</td>';
    checkin_html += '<td>Phone Number</td>';
    checkin_html += '<td>Email</td>';
    checkin_html += '</thead>';
    for (let i = 0; i < this.filtervalue.length; i++) {
      checkin_html += '<tr><td>' + (this.filtervalue.indexOf(this.filtervalue[i]) + 1) + '</td>';
      checkin_html += '<td>' + this.filtervalue[i].account.businessName + '</td>';
      checkin_html += '<td>' + this.filtervalue[i].account.accountLinkedPhNo + '</td>';
      // checkin_html += '<td>' + this.filtervalue[i].account.businessName + '</td>';
      // checkin_html += '<td>' + this.filtervalue[i].accContactInfo.primaryPhoneNumber + '</td>';
      // checkin_html += '<td>' + this.filtervalue[i].accContactInfo.primaryEmail + '</td></tr>';
    }
    printWindow.document.write('<html><head><title></title>');
    printWindow.document.write('</head><body >');
    printWindow.document.write(checkin_html);
    printWindow.document.write('</body></html>');
    printWindow.moveTo(0, 0);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  });
  }
  // for provider firestName and Last Name
  // createNameFilterExclusive() {
  //   if((this.provider_firstName!=null ||undefined)|| this.provider_lastName!=null){
  //   return 'userName-eq='+this.provider_firstName + " "+ this.provider_lastName;
  //   }
  //   else{
  //     return null;
  //   }
    
  // }
  onCategorysChange(event) {
    this.hideUserAgents = true;
   if (event.target.value !== '0') {
    this.hideUserAgents = false;
  }

}
onChange(event) {
  this.getLbels = event.target.value;
}
  clearFilterParamsofAccount() {
    this.commonService.clearFilterParams('account');
    this.commonService.clearFilterParams('category');
    this.clearFilterParamsOfDateRange();
  }
  clearFilterParams_Delete_Accounts(filterSegment) { 
    this.commonService.clearFilterParams(filterSegment);
    this.accountLinkedPhoneNumbertestSelect='startWith';
    this.clearFilterParamsOfDateRange();
    
    this.accountLinkedtestPhoneNumber='55';

  }
  clearFilterParams_Delete_UnclaimedAccount(filterSegment) {
    this.commonService.clearFilterParams(filterSegment);
    this.accountLinkedunclaimPhoneNumberSelect='eq';
    this.accountLinkedPhoneNumber='55';
    this.clearFilterParamsOfDateRange();
    this.accountclaimModel = 'Unclaimed'
  }
  clearFilterParams_Delete_Branches(filterSegment) {
    this.commonService.clearFilterParams(filterSegment);
    this.accountLinkedbranchPhoneNumberSelect='startWith';
    this.accountLinkedPhoneNumber='55';
    this.clearFilterParamsOfDateRange();
  }

  createfilterParamsOfDateRange() {
    let dateFitlerParam = '';
    if (this.createdDate_operator === 'inbetween') {
      if ((this.createdFromDate !== undefined) || (this.createdToDate !== undefined)) {
        dateFitlerParam = 'createdDate-ge=' + this.createdFromDate + '&createdDate-le=' + this.createdToDate;
      }
    } else {
      console.log('createdDate..........' + this.createdDate);
      if (this.createdDate !== undefined && this.createdDate !== '' && this.createdDate !== null) {
        dateFitlerParam = 'createdDate-' + this.createdDate_operator + '=' + this.createdDate;
      }
    }
    return dateFitlerParam;
  }
  createfilterParamsOfphone() {
    let filterParameter = '';
    if (this.operator === 'startEndWith') {
        filterParameter = 'accountLinkedPhoneNumber-' + this.operator + '=' + this.accountLinked + '||' + this.PhoneNumber;
      
    } else {
        filterParameter = 'accountLinkedPhoneNumber-' + this.operator + '=' + this.accountLinkedPhoneNumber;
    }
    return filterParameter;
  }
  clearFilterParamsOfDateRange() {
    this.createdDate_operator='eq';
    this.createdDate='';
  }
  onDomainChange(event) {
    this.subDomains = [];
    for (let i = 0; i < this.serviceSectors.length; i++) {
      // tslint:disable-next-line:triple-equals
      if (event.target.value == this.serviceSectors[i].id) {
        this.domain = this.serviceSectors[i].domain;
        for (let j = 0; j < this.serviceSectors[i].subDomains.length; j++) {
          this.subDomains.push({
            'displayName': this.serviceSectors[i].subDomains[j].displayName,
            'id': this.serviceSectors[i].subDomains[j].id, 'subDomain': this.serviceSectors[i].subDomains[j].subDomain
          });
        }
      }
    }
  }
  ngOnDestroy() {
    this.accountService.setCategoryFilterValue(0);
    this.accountService.setDomainFilterValue(0);
    this.accountService.setLicenseFilterValue(0);
    this.accountService.setAccountStatusFilter(0);
    this.accountService.setCreatedOperator('eq');
    this.resetDateFitlerParams();

  }
 
  resetDateFitlerParams() {
    this.createdDate = '';
    this.createdFromDate = '';
    this.createdToDate = '';
  }
  listAccounts() {
    // const accountType = 'accountType-eq=INDEPENDENT_SP';
    this.pagination.resetPage(0);
    const accountdelFilters = this.commonService.createfilterParams('delaccount');
    const dateRangeFiters = this.createfilterParamsOfDateRange();
    this.deleteFilters = accountdelFilters + '&' + dateRangeFiters;
    this.deleteAccountBtnDiabled = false;
    this.accountService.getAccountsData(this.deleteFilters, 'false', 0, 250)
      .subscribe(res => {
        this.accountDataSourceService.setAccountData(res);
        this.accountService.getTotalFilterCount(this.deleteFilters)
          .subscribe(data => {
            this.accountDataSourceService.setAccountCount(data);
            this.accountData.count = data;
          });
        this.accountData.filterParam = this.deleteFilters;
        this.accountData.flag = true;

        this.accountService.storeAccountData(this.accountData);
        this.router.navigate(['list'], { relativeTo: this.route });

      });

  }
  listAccountss() {
    const accountType = 'accountType-eq=INDEPENDENT_SP';
    this.pagination.resetPage(0);
    const accountdelFilters = this.commonService.createfilterParams('delunclaimedaccount');
    const dateRangeFiters = this.createfilterParamsOfDateRange();
    // const phoneNumberFiters = this.createfilterParamsOfDateRange(); 
    this.deleteFilters = accountdelFilters + '&' + dateRangeFiters + '&' + accountType;
    this.deleteAccountBtnDiabled = false;
    this.accountService.getAccountsData(this.deleteFilters, 'false', 0, 250)
      .subscribe(res => {
        this.accountDataSourceService.setAccountData(res);
        this.accountService.getTotalFilterCount(this.deleteFilters)
          .subscribe(data => {
            this.accountDataSourceService.setAccountCount(data);
            this.accountData.count = data;
          });
        this.accountData.filterParam = this.deleteFilters;
        this.accountData.flag = true;

        this.accountService.storeAccountData(this.accountData);
        this.router.navigate(['list'], { relativeTo: this.route });

      });

  }
  deleteAccountsWithoutListing() {
    const accountType = 'accountType-eq=INDEPENDENT_SP';
    this.pagination.resetPage(0);
    const accountdelFilters = this.commonService.createfilterParams('delaccount');
    const dateRangeFiters = this.createfilterParamsOfDateRange();
    this.deleteFilters = accountdelFilters + '&' + dateRangeFiters + '&' + accountType;
    const claimedStatus_of_delaccount = $('#delaccount #claimStatus  option:selected').val();
    this.accountService.getTotalFilterCount(this.deleteFilters)
      .subscribe(response => {
        const deleteCount = response;
        this.delAccountConfirmation(deleteCount, this.deleteFilters, 'Account', claimedStatus_of_delaccount);

      });
  }
  deleteAccountsWithoutListingg() {
    const accountType = 'accountType-eq=INDEPENDENT_SP';
    this.pagination.resetPage(0);
    const accountdelFilters = this.commonService.createfilterParams('delunclaimedaccount');
    const dateRangeFiters = this.createfilterParamsOfDateRange();
    this.deleteFilters = accountdelFilters + '&' + dateRangeFiters + '&' + accountType;
    const claimedStatus_of_delaccount = $('#delunclaimedaccount #claimStatus  option:selected').val();
    this.accountService.getTotalFilterCount(this.deleteFilters)
      .subscribe(response => {
        const deleteCount = response;
        this.delAccountConfirmation(deleteCount, this.deleteFilters, 'Account', claimedStatus_of_delaccount);

      });
  }

  delAccountConfirmation(delAccountcount, filters, accountType, claimedStatus?) {
    const dialogRef = this.dialog.open(DeleteAccountVerifyComponent, {
      width: '600px',
      data: { 'count': delAccountcount, 'filter': filters, 'type': accountType, 'claimedStatus': claimedStatus }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.deleteAccountBtnDiabled = true;
    });
  }
  delAccountConfirmationn(delAccountcount, filters, accountType, claimedStatus?) {
    const dialogRef = this.dialog.open(DeleteAccountVerifyyComponent, {
      width: '600px',
      data: { 'count': delAccountcount, 'filter': filters, 'type': accountType, 'claimedStatus': claimedStatus }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.deleteAccountBtnDiabled = true;
    });
  }
  listBranches() {
    this.pagination.resetPage(0);
    const accountbranchFilters = this.commonService.createfilterParams('delbranches');
    const dateRangeFiters = this.createfilterParamsOfDateRange();
    this.deletebranchFilters = accountbranchFilters + '&' + dateRangeFiters;
    this.accountService.getAccountsData(this.deletebranchFilters, 'false', 0, 10)
      .subscribe(res => {
        this.accountDataSourceService.setAccountData(res);
        this.accountService.getTotalFilterCount(this.deletebranchFilters)
          .subscribe(data => {
            this.accountDataSourceService.setAccountCount(data);
            this.accountData.count = data;
          });
        this.accountData.filterParam = this.deletebranchFilters;
        this.accountData.flag = true;

        this.accountService.storeAccountData(this.accountData);
        this.router.navigate(['list'], { relativeTo: this.route });

      });
  }

  deleteBranchesWithoutListing() {
    this.pagination.resetPage(0);
    const accountdelFilters = this.commonService.createfilterParams('delbranches');
    const dateRangeFiters = this.createfilterParamsOfDateRange();
    this.deletebranchFilters = accountdelFilters + '&' + dateRangeFiters;
    this.accountService.getTotalFilterCount(this.deletebranchFilters)
      .subscribe(response => {
        const deletebranchCount = response;
        this.delAccountConfirmation(deletebranchCount, this.deletebranchFilters, 'Branch/Branch sps');

      });
  }
  onDelAccTypeChange(event) {
    if (event.target.value === 'BRANCH_SP') {
      this.delHideEmployeeCode = false;

    } else {
      this.delHideEmployeeCode = true;
    }

  }
  onAccTypeChange(event) {
    if (event.target.value === 'BRANCH_SP') {
      this.hideEmployeeCode = false;

    } else {
      this.hideEmployeeCode = true;
    }

  }
  onCategoryChange(event) {
    if (event.target.value === 'startEndWith') {
      this.showbt = true;
     this.hideUserAgent = false;
     this.showstartend = false;
    
   }
   else {
    this.showbt = false;
     this.hideUserAgent = true;
     this.showstartend = true;
   }
 }
 onNameChange(event) {
  if (event.target.value === 'startEndWith') {
    this.showbt = true;
   this.hideName = false;
   this.showstartendName = false;
  
 }
 else {
  this.showbt = false;
   this.hideName = true;
   this.showstartendName = true;
 }
}
onPhoneChange(event) {
  if (event.target.value === 'startEndWith') {
    this.showbt = true;
   this.UnclaimPhoneAgent = false;
   this.showUnclaimPhone = false;
  
 }
 else {
  this.showbt = false;
   this.UnclaimPhoneAgent = true;
   this.showUnclaimPhone = true;
 }
}
onbranchChange(event) {
  if (event.target.value === 'startEndWith') {
    this.showbt = true;
   this.BranchPhoneAgent = false;
   this.showbranchPhone = false;
  
 }
 else {
  this.showbt = false;
   this.BranchPhoneAgent = true;
   this.showbranchPhone = true;
 }
}
onuserNameChange(event) {
  if (event.target.value === 'startEndWith') {
    this.showbt = true;
   this.hideuserName = false;
   this.showstartenduserName = false;
  
 }
 else {
  this.showbt = false;
   this.hideuserName = true;
   this.showstartenduserName = true;
 }
}
onWatsappNumChange(event) {
  if (event.target.value === 'startEndWith') {
    this.showbt = true;
   this.hidewhatsapp = false;
   this.showstartendwhatsapp = false;
  
 }
 else {
  this.showbt = false;
   this.hidewhatsapp = true;
   this.showstartendwhatsapp = true;
 }
}
onSecondaryNumChange(event) {
  if (event.target.value === 'startEndWith') {
    this.showbt = true;
   this.hideSecondPhone = false;
   this.showSecondPhone = false;
  
 }
 else {
  this.showbt = false;
   this.hideSecondPhone = true;
   this.showSecondPhone = true;
 }
}
oncontactFirstNameChange(event) {
  if (event.target.value === 'startEndWith') {
    this.showbt = true;
   this.hideContactFirstName = false;
   this.showContactFirstName = false;
  
 }
 else {
  this.showbt = false;
   this.hideContactFirstName = true;
   this.showContactFirstName = true;
 }
}
oncontactLastNameChange(event) {
  if (event.target.value === 'startEndWith') {
    this.showbt = true;
   this.hidecontactLastName = false;
   this.showcontactLastName = false;
  
 }
 else {
  this.showbt = false;
   this.hidecontactLastName = true;
   this.showcontactLastName = true;
 }
}
getLabel() {
  this.loading = true;
  this.providerLabels = [];
  this.accountService.getLabels().subscribe((data: any) => {
      this.providerLabels = data.filter(label => label.status === 'ENABLED');
// console.log(this.providerLabels)
      this.loading = false;
  });
}
showMoreFilter(){
  this.showMoreFilterSection = !this.showMoreFilterSection;
}
paymentSettlement() {
  this.api_error = '';
  this.api_success = '';
  this.disableConfirmbtn = true;
  this.accountService.paymentSettlement(this.gatewayTransactionid ,this.settlementUtr)
  .subscribe(
    data => {
      this.api_success = 'Settlemet UTR updated Successfully';
      },
   (error) => {
    this.disableConfirmbtn = false;
    this.api_error = error.error;
    }
  );

}
}
